// Backend Service API calls
import axios from "axios";

let API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "/api/v1";

// Main API client for backend services
export const apiClient = axios.create({
  baseURL: API_BASE_URL.replace(/\/$/, ""),
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access

      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

// Statistics API
export const statisticsAPI = {
  getDashboardStats: () => {
    return apiClient.get("/tasks/statistics");
  },
};

// Tasks API
export const tasksAPI = {
  getTasks: (params = {}) => {
    return apiClient.get("/tasks/", { params });
  },
  getTask: (id) => {
    return apiClient.get(`/tasks/${id}`);
  },
  createTask: (taskData) => {
    return apiClient.post("/tasks/", taskData);
  },
  updateTask: (id, taskData) => {
    return apiClient.put(`/tasks/${id}`, taskData);
  },
  deleteTask: (id) => {
    return apiClient.delete(`/tasks/${id}`);
  },
  getAssignedTasks: (params = {}) => {
    return apiClient.get("/tasks/assigned", { params });
  },
  getMentionedTasks: (params = {}) => {
    return apiClient.get("/tasks/mentioned", { params });
  },
  getCreatedTasks: (params = {}) => {
    return apiClient.get("/tasks/created", { params });
  },
  getUsers: () => {
    return apiClient.get("/tasks/users");
  },
  clearArchivedTasks: () => {
    return apiClient.post("/tasks/clear/archived");
  },
  deleteArchivedTask: (id) => {
    return apiClient.delete(`/tasks/clear/archived`, { params: { id } });
  },
};

export const usersAPI = {
  createUser: (userData) => {
    return apiClient.post("/users/", userData);
  },
  updateUser: (userId, userData) => {
    return apiClient.put(`/users/${userId}`, userData);
  },

  deleteUser: (userId) => {
    return apiClient.delete(`/users/${userId}`);
  },

  readUser: (userId) => {
    return apiClient.get(`/users/${userId}`);
  },

  listUsers: () => {
    return apiClient.get("/users/all");
  },
};

export default apiClient;
